export enum ShippingMethod {
  International = 'INTL',
  Ground = 'GROUND',
  TwoDay = 'TWO_DAY',
  NextDay = 'NEXT_DAY',
}
